import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5d56c430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar-container" }
const _hoisted_2 = { class: "customer-logo-container" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "customer-logo-img",
        src: require('@/assets/logos/bancomontepio-logo-white.png'),
        alt: "Banco Montepio"
      }, null, 8, _hoisted_3)
    ])
  ]))
}